import { PaginaCrud } from '../components/PaginaCrud'
import type { Parametro } from '../types'

export default function Configuracion() {
  return (
    <PaginaCrud<Parametro>
      titulo="Configuracion"
      recurso="configuracion"
      llave="id"
      columnas={[
        { campo: 'clave', titulo: 'Clave' },
        { campo: 'valor', titulo: 'Valor' },
        { campo: 'descripcion', titulo: 'Descripcion', render: (p) => p.descripcion || '-' },
        { campo: 'grupo', titulo: 'Grupo', render: (p) => p.grupo || '-' },
      ]}
      campos={[
        { nombre: 'clave', etiqueta: 'Clave', tipo: 'texto', requerido: true },
        { nombre: 'valor', etiqueta: 'Valor', tipo: 'texto', requerido: true },
        { nombre: 'descripcion', etiqueta: 'Descripcion', tipo: 'textarea' },
        { nombre: 'grupo', etiqueta: 'Grupo', tipo: 'texto' },
      ]}
      valorInicial={{ tenantId: 1 }}
    />
  )
}
